module.exports = __webpack_public_path__ + "img/Bhutan.8e539991.gif";